import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowUp, ArrowLeft } from 'lucide-react';

export function BackToTopButton() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!show) return null;

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-20 right-4 z-30 bg-blue-600 text-white w-10 h-10 rounded-full shadow-lg flex items-center justify-center hover:bg-blue-700 transition-colors"
      data-testid="back-to-top-btn"
      aria-label="Back to top"
    >
      <ArrowUp className="w-5 h-5" />
    </button>
  );
}

export function ContentNavFooter({ showBack = true }) {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-between gap-3 mt-8 mb-4 px-1">
      {showBack && (
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-1.5 text-xs font-semibold text-blue-600 hover:text-blue-700 uppercase tracking-wider"
          data-testid="content-back-btn"
        >
          <ArrowLeft className="w-3.5 h-3.5" />
          Back
        </button>
      )}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="flex items-center gap-1.5 text-xs font-semibold text-blue-600 hover:text-blue-700 uppercase tracking-wider ml-auto"
        data-testid="content-back-to-top-btn"
      >
        <ArrowUp className="w-3.5 h-3.5" />
        Back to Top
      </button>
    </div>
  );
}
